import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Feature } from '@turf/turf';

import { ErrorHandlerService } from '../../../core/framework/error-handler.service';
import { Usuario } from './usuario.model';
import { DefaultService } from 'src/app/core/framework/default-service';
import { PermissaoNome } from '../../perfil-de-acesso/permissao/permissao-nome.enum';
import { PerfilDeAcessoService } from '../../perfil-de-acesso/perfil-de-acesso.service';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService extends DefaultService<Usuario> {
  static URL = '/api/seguranca/v1/usuarios';

  constructor(
    public httpClient: HttpClient,
    public errorHandlerService: ErrorHandlerService,
    public perfilDeAcessoService: PerfilDeAcessoService
  ) {
    super(
      httpClient,
      errorHandlerService,
      UsuarioService.URL
    );
  }

  static getUsuarioFromLocalStorage(): Usuario {
    return Object.assign(new Usuario(), JSON.parse(localStorage.getItem('usuario')));
  }

  fetch(id: number): Observable<Usuario> {
    const usuarioLogado = UsuarioService.getUsuarioFromLocalStorage();
    if ( usuarioLogado.id === Number(id) ) {
      return this.buscarMeusDados();
    }
    else {
      return super.fetch(id);
    }
  }

  buscarMeusDados(): Observable<Usuario> {
    return this.httpClient.get<Usuario>(`${UsuarioService.URL}/buscarMeusDados`)
                          .pipe(
                            catchError( err => throwError(this.errorHandlerService.handle(err)) )
                          );
  }

  getUsuarioLogadoListaDePermissoes(): Array<PermissaoNome> {
    const token = localStorage.getItem('auth-token');
    const authorities = new JwtHelperService().decodeToken(token).authorities;
    return Object.assign(new Array<PermissaoNome>(), authorities);
  }

  usuarioLogadoTemPermissao(permissaoNome: PermissaoNome): boolean {
    const permissoes: Array<PermissaoNome> = this.getUsuarioLogadoListaDePermissoes();
    return permissoes.includes(permissaoNome);
  }

  usuarioLogadoTemQualquerDasPermissoes(...permissaoNome: PermissaoNome[]): boolean {
    const permissoes: Array<PermissaoNome> = this.getUsuarioLogadoListaDePermissoes();
    return permissoes.some( o => permissaoNome.includes(o) );
  }

  buscarUltimaPosicaoDosUsuariosAtivos(): Observable<Feature[]> {
    return this.httpClient.get<Feature[]>(`${UsuarioService.URL}/buscarUltimaPosicaoDosUsuariosAtivos`)
                          .pipe(
                            catchError( err => throwError(this.errorHandlerService.handle(err)) )
                          );
  }

}
